import PropTypes from 'prop-types';
import React from 'react';

import { scsPermissions } from '../../../utils/tab-permissions';
import { PageTemplate } from '../../reusable';

import Main from './Main';

const StoreOpeningOnboarding = (props) => (
  <PageTemplate
    auth={scsPermissions}
    description="Onboard and set up new stores with the configurations and operations needed to go live."
    help={(
      <a
        className="ncss-cta-primary-dark underline text-color-secondary"
        href="https://confluence.nike.com/display/RCFITC/RCF+KB+-+SCS+UI"
        rel="noopener noreferrer"
        target="_blank"
      >
        Click here to view the KB
      </a>
    )}
    page={<Main />}
    path={props.location.pathname}
    title="Store Opening - Onboarding"
  />
);

StoreOpeningOnboarding.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string.isRequired }).isRequired,
};

export default StoreOpeningOnboarding;
